import { render, staticRenderFns } from "./withdrawCard.vue?vue&type=template&id=6481f0a2"
import script from "./withdrawCard.vue?vue&type=script&lang=js"
export * from "./withdrawCard.vue?vue&type=script&lang=js"
import style0 from "./withdrawCard.vue?vue&type=style&index=0&id=6481f0a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports